/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_FAVOURITES_FILL': {
    width: 16,
    height: 16,
    viewBox: '0 0 84.74 107.91',
    data: '<path pid="0" d="M8.46 64.15c3.41 6.07 7.41 11.86 10.41 18.09a75.31 75.31 0 0 0 14.92 21.22c6.08 5.92 6.07 6 12.37-.05 3.83-3.7 7.53-7.44 9.77-12.51 2.43-5.52 5.49-10.77 8.4-16.08 1.27-2.33 3-4.43 4.25-6.74a238.55 238.55 0 0 0 11.66-25.11c3.67-8.89 5.72-17.62 3.73-27.58-2.26-11.28-15-21-27.57-11.47-.28.22-.52.5-.79.73L40.24 17.46c-2.5-3.07-4.91-6.58-7.87-9.55-4.24-4.26-9.44-6.69-15.54-4.72A20.94 20.94 0 0 0 3.27 15.27C-.27 23.62-.23 32.39.21 41.11c.42 8.35 4.2 15.84 8.25 23.04z" _fill="currentColor"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_FAVOURITES_FILL.js